// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1PHCK","title":"Header_title__3ToQn","left":"Header_left__3xMgq","clinicName":"Header_clinicName__nfWNF"};